<template>
  <div>
    <form method="post" :action="this.responseLoginSAML.url">
      <input style="display: none" type="submit" id="postLoginSubmitButton" />
      <input
        type="hidden"
        name="SAMLResponse"
        :value="this.responseLoginSAML.data.SAMLResponse"
        data-vs-input="auth-saml-middleware-input-samlresponse"
      />
      <input type="hidden" name="RelayState" :value="this.responseLoginSAML.data.RelayState" />
      <noscript>
        <button id="buttonSubmit" type="submit" class="btn" data-vs-button="auth-saml-middleware-btn-submit">redirect...</button>
      </noscript>
    </form>
  </div>
</template>

<script>
import Auth from '@/apiClient/Auth'
export default {
  name: 'authSAML',
  data() {
    return {
      responseLoginSAML: {
        url: '',
        data: {
          SAMLResponse: '',
          RelayState: ''
        }
      },
      auth: null
    }
  },
  methods: {
    async redirectToSAML() {
      let queryParamsSAML = this.$route.params.queryParamsSAML
      try {
        await this.auth
            .loginSAML(
                queryParamsSAML.queryPath.SAMLRequest,
                queryParamsSAML.queryPath.RelayState
            )
            .then(response => {
              let responseSAML = response.data.data[0]
              this.responseLoginSAML.url = responseSAML.url
              this.responseLoginSAML.data.SAMLResponse = responseSAML.data.SAMLResponse
              this.responseLoginSAML.data.RelayState = responseSAML.data.RelayState
              this.$nextTick(() => {
                let button = document.getElementById('postLoginSubmitButton')
                button.click()
              })
            })
      } catch (e) {
        console.error('error', e.response)
        await this.$store.dispatch('clearState')
        await this.$router.push('login')
      }
    }
  },
  mounted() {
    this.redirectToSAML()
  },
  created() {
    this.auth = new Auth()

  }
}
</script>

<style scoped></style>
